import * as $ from "jquery";

export function initToggleSideBar() {
  $(".side-arrow").off('click');
  $(".side-arrow").click(() => {
    $(".side-arrow").toggleClass("hide");
    $(".sk-cms-sidebar-wap").toggleClass("hide");
  });
}
